<template>
  <Layout>
    <h1>
      <router-link :to="{ path: `/production/jobs/jobDetails/${jobNum}` }">
        <i class="invoice-back-icon bx bx-left-arrow-circle"></i>
      </router-link>
    </h1>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="invoice-title">
              <h3
                v-if="
                  !integrationDetails.qbIntegration.active &&
                    !integrationDetails.qbIntegration.invoicing
                "
                class="float-right font-size-20"
              >
                Order
              </h3>
              <div class="mb-4">
                <img
                  src="@/assets/images/kaliLogo.png"
                  alt="logo"
                  height="40"
                />
              </div>
              <div class="row">
                <div class="col-6">
                  <address>
                    <strong>Order Detail:</strong>
                    <br />Job #: {{ jobNum }} <br />Job Date: {{ jobDate }}
                    <br />Job Description: {{ jobDescription }}
                  </address>
                </div>
                <div class="col-6 text-right">
                  <address>
                    <strong>Order Date:</strong>
                    <br />{{ date }}
                  </address>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6">
                <address>
                  <strong>Sold By:</strong>
                  <br />{{ billingInfo.companyName }} <br />{{
                    billingInfo.address
                  }}
                  <br />{{ billingInfo.city }}, {{ billingInfo.province }}
                  <br />{{ billingInfo.postal }} <br />{{ billingInfo.phone }}
                  <br />{{ billingInfo.email }}
                </address>
              </div>
              <div class="col-6 text-right">
                <address>
                  <strong>Bill To:</strong>
                  <br />{{ customer.name }}
                </address>
              </div>
            </div>
            <div class="row"></div>

            <!-- Times -->
            <div v-if="charges.length >= 1" class="p-2 mt-3">
              <h3 class="font-size-16">Order summary</h3>
            </div>
            <div v-if="charges.length >= 1" class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 3%">No.</th>
                    <th style="width: 100px">Date</th>
                    <th>Description</th>
                    <th
                      v-if="
                        integrationDetails.qbIntegration.active &&
                          integrationDetails.qbIntegration.invoicing
                      "
                      style="width: 275px"
                      class="d-print-none"
                    >
                      Account
                    </th>
                    <th>Quantity</th>
                    <th>Rate</th>
                    <th class="text-right">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(charge, index) in charges" :key="charge.index">
                    <td>
                      {{ index }}
                    </td>
                    <td>
                      {{ charge.date }}
                    </td>
                    <td>
                      {{ charge.description }}
                    </td>
                    <td
                      v-if="
                        integrationDetails.qbIntegration.active &&
                          integrationDetails.qbIntegration.invoicing
                      "
                      class="d-print-none"
                    >
                      <b-form-select
                        :options="qbIntegration.accounts"
                        v-model="charge.incomeAccount"
                        text-field="name"
                        value-field="id"
                      >
                      </b-form-select>
                    </td>
                    <td>
                      {{ charge.hours }}
                    </td>
                    <td>${{ charge.rate }}</td>
                    <td class="text-right">${{ charge.lineTotal }}</td>
                  </tr>
                  <tr>
                    <!-- <td class="d-print-none"></td> -->
                    <td
                      :colspan="
                        integrationDetails.qbIntegration.active &&
                        integrationDetails.qbIntegration.invoicing
                          ? '4'
                          : '3'
                      "
                      class="text-right"
                    >
                      <strong>Total(s)</strong>
                    </td>
                    <td class="text-left">{{ roundedTotals.hoursTotal }}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td
                      :colspan="
                        integrationDetails.qbIntegration.active &&
                        integrationDetails.qbIntegration.invoicing
                          ? '6'
                          : '5'
                      "
                      class="text-right"
                      style="width: 90%"
                    >
                      <strong>Sub Total</strong>
                    </td>
                    <td id="lbl_subtotal" class="text-right">
                      ${{ roundedTotals.hoursSubTotal }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /Times -->
            <!-- Products -->
            <div v-if="products.length >= 1" class="p-2 mt-3">
              <h3 class="font-size-16">Products summary</h3>
            </div>
            <div v-if="products.length >= 1" class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 3%">No.</th>
                    <th style="width: 100px">Date</th>
                    <th>Name</th>
                    <th
                      v-if="
                        integrationDetails.qbIntegration.active &&
                          integrationDetails.qbIntegration.invoicing
                      "
                      style="width: 275px"
                      class="d-print-none"
                    >
                      Account
                    </th>
                    <th>Quantity</th>
                    <th>Rate</th>
                    <th class="text-right">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(product, index) in products" :key="product.index">
                    <td>
                      {{ index }}
                    </td>
                    <td>
                      {{ product.date }}
                    </td>
                    <td>
                      {{ product.products }}
                    </td>
                    <td
                      v-if="
                        integrationDetails.qbIntegration.active &&
                          integrationDetails.qbIntegration.invoicing
                      "
                      class="d-print-none"
                    >
                      <b-form-select
                        :options="qbIntegration.accounts"
                        v-model="product.incomeAccount"
                        text-field="name"
                        value-field="id"
                      >
                      </b-form-select>
                    </td>
                    <td>
                      {{ product.quantity }}
                    </td>
                    <td>${{ product.rate }}</td>
                    <td class="text-right">${{ product.lineTotal }}</td>
                  </tr>
                  <tr>
                    <!-- <td class="d-print-none"></td> -->
                    <td
                      :colspan="
                        integrationDetails.qbIntegration.active &&
                        integrationDetails.qbIntegration.invoicing
                          ? '4'
                          : '3'
                      "
                      class="text-right"
                    >
                      <strong>Total(s)</strong>
                    </td>
                    <td class="text-left">{{ roundedTotals.productsTotal }}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <!-- <td class="d-print-none"></td> -->
                    <td
                      :colspan="
                        integrationDetails.qbIntegration.active &&
                        integrationDetails.qbIntegration.invoicing
                          ? '6'
                          : '5'
                      "
                      class="text-right"
                      style="width: 90%"
                    >
                      <strong>Sub Total</strong>
                    </td>
                    <td id="lbl_subtotal" class="text-right">
                      ${{ roundedTotals.productsSubTotal }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /Products -->

            <!-- Procurements -->
            <div v-if="procurements.length >= 1" class="p-2 mt-3">
              <h3 style="display: inline-block" class="font-size-16 mr-2">
                Procurements summary
              </h3>

              <i
                v-if="procurementsNotReceived.length >= 1"
                id="popover-target-1"
                class="bx bx-info-circle d-print-none"
                style="
                  display: inline-block;
                  color: red;
                  font-size: 1.5em;
                  cursor: pointer;
                "
              ></i>
              <b-popover
                target="popover-target-1"
                triggers="click blur"
                placement="top"
              >
                Procurement items with no received amount have been hidden.
                Click below to view these items.
                <br />
                <b-button
                  v-b-modal.notReceivedModal
                  variant="primary"
                  size="sm"
                  class="m-auto"
                  >View items</b-button
                >
              </b-popover>
            </div>
            <b-modal
              id="notReceivedModal"
              title="Procurement Items With No Received Amount"
              ok-only
            >
              <table class="table" style="text-align: center">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Date</th>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Quoted Amount</th>
                  </tr>
                  <tr
                    v-for="(procurement, index) in procurementsNotReceived"
                    :key="index"
                  >
                    <td>
                      {{ index }}
                    </td>
                    <td>
                      {{ procurement.date }}
                    </td>
                    <td>
                      {{ procurement.name }}
                    </td>

                    <td>
                      {{ procurement.type }}
                    </td>
                    <td>
                      {{ procurement.quotedAmount }}
                    </td>
                  </tr>
                </thead>
              </table>
            </b-modal>
            <div v-if="procurements.length >= 1" class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 3%">No.</th>
                    <th style="width: 100px">Date</th>
                    <th>Name</th>
                    <!-- <th
                      v-if="
                        integrationDetails.qbIntegration.active &&
                          integrationDetails.qbIntegration.invoicing
                      "
                      style="width: 275px;"
                      class="d-print-none"
                    >
                      Account
                    </th> -->
                    <th>Type</th>
                    <th class="text-right">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(procurement, index) in procurements" :key="index">
                    <td v-if="procurement.receivedAmount">
                      {{ index }}
                    </td>
                    <td v-if="procurement.receivedAmount">
                      {{ procurement.date }}
                    </td>
                    <td v-if="procurement.receivedAmount">
                      {{ procurement.name }}
                    </td>
                    <!-- <td
                      v-if="
                        integrationDetails.qbIntegration.active &&
                          integrationDetails.qbIntegration.invoicing
                      "
                      class="d-print-none"
                    >
                      <b-form-select
                        :options="qbIntegration.accounts"
                        v-model="product.incomeAccount"
                        text-field="name"
                        value-field="id"
                      >
                      </b-form-select>
                    </td> -->
                    <td v-if="procurement.receivedAmount">
                      {{ procurement.type }}
                    </td>
                    <td v-if="procurement.receivedAmount" class="text-right">
                      {{ markedUpAmount(procurement).toFixed(2) }}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td
                      :colspan="
                        integrationDetails.qbIntegration.active &&
                        integrationDetails.qbIntegration.invoicing
                          ? '4'
                          : '3'
                      "
                      class="text-right"
                      style="width: 90%"
                    >
                      <strong>Sub Total</strong>
                    </td>
                    <td class="text-right">
                      ${{ roundedTotals.procurementsSubTotal }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /Procurements -->

            <!-- Order Summary -->
            <div class="table-responsive">
              <table class="table">
                <tr>
                  <td class="text-right" style="width: 90%; border: none">
                    <strong>Order Sub Total</strong>
                  </td>
                  <td id="lbl_subtotal" class="text-right" style="border: none">
                    <h5>${{ roundedTotals.subTotal }}</h5>
                  </td>
                </tr>
                <tr>
                  <td class="border-0 text-right">
                    <strong>GST</strong>
                  </td>
                  <td id="lbl_gst" class="border-0 text-right">
                    <h5>${{ roundedTotals.gst }}</h5>
                  </td>
                </tr>
                <tr>
                  <td class="border-0 text-right">
                    <strong>Total</strong>
                  </td>
                  <td class="border-0 text-right">
                    <h4 id="lbl_total" class="m-0">
                      ${{ roundedTotals.total }}
                    </h4>
                  </td>
                </tr>
              </table>
            </div>
            <!-- /Order Summary -->

            <div class="d-print-none">
              <div class="float-right">
                <a
                  href="javascript:window.print()"
                  class="btn w-md btn-success mr-2"
                >
                  <i class="fa fa-print mr-2"></i> Print
                </a>
                <!-- <a href="javascript: void(0);" class="btn btn-primary w-md ml-1">Send</a> -->
                <b-button
                  v-if="
                    this.integrationDetails.qbIntegration.invoicing &&
                      this.integrationDetails.qbIntegration.active
                  "
                  @click="createQBInvoice()"
                  variant="primary"
                  class="btn btn-label btn-primary"
                  :class="customer.integration_id == null ? 'disabled' : null"
                  :disabled="customer.integration_id == null"
                  ><i class="bx bx-cloud-upload label-icon"></i>Import
                  Invoice</b-button
                >
              </div>
            </div>
            <div v-if="customInvoiceTemplateActive" class="d-print-none">
              <div class="float-right">
                <a class="btn w-md btn-success mr-2" @click="generateCSV()">
                  <i class="fa fa-file-excel mr-2"></i> Export to CSV
                </a>
              </div>
            </div>
            <div
              v-if="
                customer.integration_id == null &&
                  integrationDetails.qbIntegration.active &&
                  integrationDetails.qbIntegration.invoicing
              "
              class="float-left d-print-none"
              style="color: #f46a6a"
            >
              <span
                >Invoice cannot be imported as the customer was created through
                Kali before the accounting integration was setup.</span
              >
              <br />
              <span>
                In order to resolve this issue, delete the customer and re-add
                them to Kali.
                <strong
                  >Then edit this job to be associated with the new
                  customer</strong
                ></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
import appConfig from '@/app.config';
import Swal from 'sweetalert2';
import axios from 'axios';
import moment from 'moment';
import Papa from 'papaparse';

import {
  getCompanyBillingInfo,
  updateQBOIntegrationDetails,
  getQBIncomeAccounts,
} from '../helper/dbHelpers.js';
import { parseBoolFromString } from '../helper/helpers';

import firebase from 'firebase';

export default {
  page: {
    title: 'invoice',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: 'Invoice ',
      name: 'invoice',
      items: [],
      jobNum: null,
      jobDescription: null,
      jobDate: null,
      customer: {
        name: null,
        integration_id: null,
      },
      date: null,
      charges: [],
      products: [],
      procurements: [],
      procurementsNotReceived: [],
      totals: {
        hoursTotal: 0,
        productsTotal: 0,
        procurementsSubTotal: 0,
        hoursSubTotal: 0,
        productsSubTotal: 0,
        subTotal: 0,
        gst: 0,
        total: 0,
      },
      billingInfo: {
        companyName: null,
        address: null,
        city: null,
        province: null,
        postal: null,
        email: null,
        phone: null,
      },
      qbIntegration: {
        accounts: [],
        defaultAccount: {
          name: null,
          id: null,
          sync_token: null,
        },
      },
      invoiceErrorMessage: null,
      charges_headers: {
        header: 'header',
      },
    };
  },
  computed: {
    links: function() {
      return [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'search jobs',
          href: '/production/jobs/searchJobs',
        },
        {
          text: 'job details',
          href: `/production/jobs/jobDetails/${this.jobNum}`,
        },
        {
          text: 'invoice',
          href: '/production/invoices/invoice',
          active: true,
        },
      ];
    },
    roundedTotals: function() {
      return {
        hoursTotal: this.totals.hoursTotal.toFixed(2),
        productsTotal: this.totals.productsTotal.toFixed(2),
        procurementsSubTotal: this.totals.procurementsSubTotal.toFixed(2),
        hoursSubTotal: this.totals.hoursSubTotal.toFixed(2),
        productsSubTotal: this.totals.productsSubTotal.toFixed(2),
        subTotal: this.totals.subTotal.toFixed(2),
        gst: this.totals.gst.toFixed(2),
        total: this.totals.total.toFixed(2),
      };
    },
    integrationDetails: function() {
      return {
        sageIntegration: {},
        qbIntegration: {
          active: parseBoolFromString(sessionStorage.getItem('qb_active')),
          invoicing: parseBoolFromString(
            sessionStorage.getItem('qb_invoicing')
          ),
        },
      };
    },
    customInvoiceTemplateActive: function() {
      return this.$route.params.invoiceTemplateTotals.length >= 1
        ? true
        : false;
    },
  },
  methods: {
    markedUpAmount: function(item) {
      if (item.receivedAmount) {
        if (
          item.markup !== null &&
          item.markup !== undefined &&
          item.markup !== ''
        ) {
          if (item.markupType === 'flatRate') {
            return Number(item.markup);
          } else if (item.markupType === 'dollar') {
            return Number(item.receivedAmount) + Number(item.markup);
          } else if (item.markupType === 'percentage') {
            return (
              Number(item.receivedAmount) +
              (Number(item.markup) / 100) * Number(item.receivedAmount)
            );
          }
          return Number(item.receivedAmount);
        } else {
          return Number(item.receivedAmount);
        }
      } else {
        return 0;
      }
    },
    getCompanyInfo: function() {
      getCompanyBillingInfo()
        .then((info) => {
          let billingInfo = info.data().billingInfo;
          //start populating the company info.
          this.billingInfo = {
            companyName: billingInfo.name != undefined ? billingInfo.name : '',
            address:
              billingInfo.address != undefined ? billingInfo.address : '',
            city: billingInfo.city != undefined ? billingInfo.city : '',
            province:
              billingInfo.province.abbreviation != undefined
                ? billingInfo.province.abbreviation
                : '',
            country:
              billingInfo.country != undefined ? billingInfo.country : '',
            postal:
              billingInfo.postalCode != undefined ? billingInfo.postalCode : '',
            email: billingInfo.email != undefined ? billingInfo.email : '',
            phone: billingInfo.phone != undefined ? billingInfo.phone : '',
          };
        })
        .catch(() => {
          Swal.fire({
            title: `We were not able to get your company's billing information. Have you entered your billing info in the settings page?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No, take me there',
          }).then((result) => {
            if (!result.isConfirmed) {
              //send the user to the settings page.
              this.$router.push({ name: 'settingsContainer' });
            }
          });
        });
    },
    createQBInvoice: function() {
      let lineItems = [];
      //loop the times and create line items for each.
      this.charges.forEach((time) => {
        let account = {
          id: this.qbIntegration.accounts.find(
            (o) => o.id == time.incomeAccount
          ).id,
          name: this.qbIntegration.accounts.find(
            (o) => o.id == time.incomeAccount
          ).name,
          sync_token: this.qbIntegration.accounts.find(
            (o) => o.id == time.incomeAccount
          ).sync_token,
        };
        lineItems.push({
          amount: time.lineTotal,
          description: time.description,
          date: time.date,
          hours: time.hours,
          rate: time.rate,
          account: account,
        });
      });

      let sendParams = {
        access_token: `${sessionStorage.getItem('qb_access_token')}`,
        refresh_token: `${sessionStorage.getItem('qb_refresh_token')}`,
        realmId: `${sessionStorage.getItem('qb_realmId')}`,
        org: sessionStorage.getItem('org'),
        customerID: this.customer.integration_id,
        lineItems: lineItems,
      };
      axios
        .get(
          `https://us-central1-kali-45420.cloudfunctions.net/createQBInvoice`,
          {
            // axios.get(`http://localhost:5000/kali-45420/us-central1/createQBInvoice`, {
            params: {
              sendParams,
            },
          }
        )
        .then(() => {
          Swal.fire('Success!', 'Invoice imported successfully.', 'success');
        })
        .catch((err) => {
          //check to see if the status code is 500. If it is, try to retrieve the updated tokens from the db.
          if (
            err.response.status == 401 &&
            err.response.data.response == 'Token expired'
          ) {
            console.log('token expired');
            //refresh the token.
            let sendParams = {
              refresh_token: `${sessionStorage.getItem('qb_refresh_token')}`,
              org: sessionStorage.getItem('org'),
              realmId: sessionStorage.getItem('qb_realmId'),
            };
            axios
              .get(
                `https://us-central1-kali-45420.cloudfunctions.net/refreshQBToken`,
                {
                  // axios.get(`http://localhost:5000/kali-45420/us-central1/refreshQBToken`, {
                  params: {
                    sendParams,
                  },
                }
              )
              .then(async (response) => {
                let success = await updateQBOIntegrationDetails(
                  response.data.response.access_token,
                  response.data.response.refresh_token,
                  sessionStorage.getItem('qb_invoicing'),
                  sessionStorage.getItem('qb_customers'),
                  sessionStorage.getItem('qb_realmId')
                );
                if (success) {
                  this.createQBInvoice();
                } else {
                  console.log(
                    'WError updating QuickBooks integration details.'
                  );
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            console.log(`Error importing invoice into QuickBooks`);
            console.log(err.response.data.response);
            Swal.fire(
              'Error!',
              `Error importing invoice into QuickBooks: ${err.response.data.response}`,
              'error'
            );
          }
        });
    },
    getQBAccounts: function() {
      this.qbIntegration.accounts = [];
      getQBIncomeAccounts()
        .then((response) => {
          response.data.response.Item.forEach((account) => {
            this.qbIntegration.accounts.push({
              name: account.Name,
              id: account.Id,
              sync_token: account.SyncToken,
            });
          });
        })
        .catch((err) => {
          //check to see if the status code is 500. If it is, try to retrieve the updated tokens from the db.
          if (
            err.response.status == 401 &&
            err.response.data.response == 'Token expired'
          ) {
            console.log('token expired');
            //refresh the token.
            let sendParams = {
              refresh_token: `${sessionStorage.getItem('qb_refresh_token')}`,
              org: sessionStorage.getItem('org'),
              realmId: sessionStorage.getItem('qb_realmId'),
            };
            axios
              .get(
                `https://us-central1-kali-45420.cloudfunctions.net/refreshQBToken`,
                {
                  // axios.get(`http://localhost:5000/kali-45420/us-central1/refreshQBToken`, {
                  params: {
                    sendParams,
                  },
                }
              )
              .then(async (response) => {
                let success = await updateQBOIntegrationDetails(
                  response.data.response.access_token,
                  response.data.response.refresh_token,
                  sessionStorage.getItem('qb_invoicing'),
                  sessionStorage.getItem('qb_customers'),
                  sessionStorage.getItem('qb_realmId'),
                  sessionStorage.getItem('qb_defaultAccountId'),
                  sessionStorage.getItem('qb_defaultAccountName')
                );
                if (success) {
                  this.getQBAccounts();
                } else {
                  console.log('error updating QuickBooks integration details.');
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            console.log(err);
            console.log(`Error getting the QuickBooks customers data set`);
            Swal.fire(
              'Error!',
              'Error getting the QuickBooks customers data set.',
              'error'
            );
          }
        });
    },
    getQBCustomerInfo: function() {
      firebase
        .firestore()
        .collection('customers')
        .where('org', '==', sessionStorage.getItem('org'))
        .where('displayName', '==', this.customer.name)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data().qb_id == undefined) {
              this.invoiceErrorMessage = '';
              this.customer.integration_id = null;
            } else {
              this.customer.integration_id = doc.data().qb_id;
            }
          });
        })
        .catch((err) => {
          console.log(`Error getting customer info: ${err}`);
          Swal.fire('Error!', 'Error getting customer info.', 'error');
        });
    },
    getCustomerInfo: function() {
      firebase
        .firestore()
        .collection('customers')
        .where('org', '==', sessionStorage.getItem('org'))
        .where('displayName', '==', this.customer.name)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            //grab the billing info, if it exists.
            if (doc.data().billingInfo != undefined) {
              this.customer.billingInfo = doc.data().billingInfo;
            }
          });
        })
        .catch((err) => {
          console.log(`Error getting customer info: ${err}`);
          Swal.fire('Error!', 'Error getting customer info.', 'error');
        });
    },
    generateCSV: function() {
      //loop the report data and create the report.
      let subtotalsStirng = '\r\n\r\n';
      let totalsString = '\r\n\r\n';
      let widthPlaceholder = '';
      let totalSum = 0;
      this.$route.params.invoiceTemplateTotals.forEach((total, index) => {
        if (total.sum) {
          subtotalsStirng += `${total.subtotal},`;
          if (!isNaN(Number(total.subtotal))) {
            totalSum = Number(totalSum) + Number(total.subtotal);
          }
        } else {
          //if sum is false, just skip it.
          subtotalsStirng += ',';
        }

        //create a string of commas that is the same length as the report, mnus 1, so we can place the report total in the bottom right of the report and it is
        //dynamically generated.
        if (index <= this.$route.params.invoiceTemplateTotals.length - 3) {
          widthPlaceholder += ',';
        }
      });

      //if we have billing details for the customer, parse it here. If not, just empty string, so we don't have a bunch of empty rows.
      let customerBillingInfo = '';
      if (this.customer.billingInfo != undefined) {
        customerBillingInfo = `${this.customer.billingInfo.address}
        ,${this.customer.billingInfo.city} ${this.customer.billingInfo.province} ${this.customer.billingInfo.postal}`;
      }

      //create the header for the spreadsheet.
      let spreadsheetHeader = `${this.billingInfo.companyName}${widthPlaceholder}Invoice #
        ${this.billingInfo.address}${widthPlaceholder}Invoice Date
        ${this.billingInfo.city}
        ${this.billingInfo.postal}
        ${this.billingInfo.phone}
        Bill to: , ${this.customer.name}
        ,${customerBillingInfo}\r\n\r\n`;

      totalsString += `${widthPlaceholder} Subtotal, ${Number(totalSum).toFixed(
        2
      )}
      ${widthPlaceholder} GST, ${(totalSum * 0.05).toFixed(2)}
      ${widthPlaceholder} Total, ${(totalSum * 1.05).toFixed(2)}`;

      var blob = new Blob(
        [
          spreadsheetHeader +
            Papa.unparse(this.$route.params.invoiceTemplateItems) +
            subtotalsStirng +
            totalsString,
        ],
        {
          type: 'text/csv;charset=utf-8;',
        }
      );

      var link = document.createElement('a');

      var url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute(
        'download',
        `${this.billingInfo.companyName} ${this.date}.csv`
      );
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  mounted: function() {
    this.getCompanyInfo();
    this.jobNum = this.$route.params.jobNum;
    this.jobDescription = this.$route.params.jobDescription;
    this.jobDate = this.$route.params.jobDate;
    this.customer.name = this.$route.params.jobCustomer;
    this.date = moment(this.$route.params.date).format('MMM DD, YY');
    this.charges = this.$route.params.times;
    this.products = this.$route.params.products;
    this.procurements = this.$route.params.procurements;

    for (let i = 0; i <= this.charges.length - 1; i++) {
      this.totals.hoursTotal += Number(this.charges[i].hours);
      this.totals.hoursSubTotal += Number(this.charges[i].lineTotal);
      this.totals.subTotal += Number(this.charges[i].lineTotal);
      this.charges[i].incomeAccount = sessionStorage.getItem(
        'qb_defaultAccountId'
      );
    }

    for (let i = 0; i <= this.products.length - 1; i++) {
      this.totals.productsTotal += Number(this.products[i].quantity);
      this.totals.productsSubTotal += Number(this.products[i].lineTotal);
      this.totals.subTotal += Number(this.products[i].lineTotal);
      this.products[i].incomeAccount = sessionStorage.getItem(
        'qb_defaultAccountId'
      );
    }

    this.procurements.sort((a, b) => a.date - b.date);
    for (let i = 0; i <= this.procurements.length - 1; i++) {
      this.procurements[i].date = moment(this.procurements[i].date).format(
        'MMM DD, YY'
      );
      //use received amount if present, return 0 if not present
      if (
        this.procurements[i].receivedAmount !== null &&
        this.procurements[i].receivedAmount !== undefined &&
        this.procurements[i].receivedAmount !== ''
      ) {
        if (
          this.procurements[i].markupType !== null &&
          this.procurements[i].markupType !== undefined &&
          this.procurements[i].markup !== null &&
          this.procurements[i].markup !== undefined &&
          this.procurements[i].markup !== ''
        ) {
          if (this.procurements[i].markupType === 'flatRate') {
            this.totals.procurementsSubTotal += Number(
              this.procurements[i].markup
            );
          } else if (this.procurements[i].markupType === 'dollar') {
            this.totals.procurementsSubTotal +=
              Number(this.procurements[i].receivedAmount) +
              Number(this.procurements[i].markup);
          } else if (this.procurements[i].markupType === 'percentage') {
            this.totals.procurementsSubTotal +=
              (Number(this.procurements[i].markup) / 100) *
                Number(this.procurements[i].receivedAmount) +
              Number(this.procurements[i].receivedAmount);
          }
        } else {
          this.totals.procurementsSubTotal += Number(
            this.procurements[i].receivedAmount
          );
        }
      } else {
        this.totals.procurementsSubTotal += 0;
        this.procurementsNotReceived.push(this.procurements[i]);
      }
      // this.products[i].incomeAccount = sessionStorage.getItem(
      //   'qb_defaultAccountId'
      // );
    }
    this.totals.subTotal += this.totals.procurementsSubTotal;
    this.totals.gst = this.totals.subTotal * 0.05;
    this.totals.total = this.totals.subTotal + this.totals.gst;

    this.items = this.links;

    if (
      this.integrationDetails.qbIntegration.active &&
      this.integrationDetails.qbIntegration.invoicing
    ) {
      this.getQBAccounts();
      this.getQBCustomerInfo();
    } else {
      this.getCustomerInfo();
    }
  },
};
</script>

<style scoped>
/* Back icon styles */
.invoice-back-icon {
  color: #495057;
}
.invoice-back-icon:hover {
  color: #556de5;
  transition: 0.2s ease-in;
}
</style>
